let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("54XZx")).then(() => parcelRequire('cJg6M'));